<template>
  <div
    class="flex shadow-md p-4 rounded-lg w-full lg:w-2/12 m-1 items-center clickable-card"
    @click="handleClick"
  >
    <div class="flex flex-col mr-4 pr-4">
      <feather-icon
        :icon="icon"
        class="p-3 inline-flex rounded-full"
        :class="[`text-${color}`, { 'mb-4': !iconRight }]"
        :style="{ background: `rgba(var(--vs-${color}),.15)` }"
      ></feather-icon>
    </div>
    <div class="flex flex-col text-left">
      <div class="text-lg font-semibold">{{ value }}</div>
      <div>
        {{ label }}
        <br>
        <span class="text-sm ">{{ subtitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: 'icon-placeholder',
    },
    label: {
      type: String,
      default: 'Label',
    },
    subtitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    iconPack: {
      type: String,
      default: 'material-icons',
    },
  },
  data() {
    return {
      iconRight: 'default-icon',
    };
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped>
.shadow-md {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.clickable-card {
  cursor: pointer;
}
</style>
